import React from 'react';
import { observer } from 'mobx-react';
import { ColorPicker, Form, InputNumber, Space } from 'antd';

const stripHash = (hex) => (hex || '').replace(/^#/, '');

// StandardMaterial params the editor applies to the curtain panels (bare hex).
const COLOR_FIELDS = [
    { key: 'diffuseColor', label: 'Diffuse (tint)', fallback: '#ffffff' },
    { key: 'specularColor', label: 'Specular (shine)', fallback: '#000000' },
    { key: 'emissiveColor', label: 'Emissive', fallback: '#000000' },
    { key: 'ambientColor', label: 'Ambient', fallback: '#ffffff' },
];

/**
 * Curtain variant fields: the fabric swatch is the uploaded image; these are
 * the panel material (opacity + colors) and the pattern's square repeat size.
 * The width/height picker ranges live in the shared Resizable section.
 */
@observer
export class CurtainVariantSpecific extends React.Component {
    render() {
        const { variant, onChange } = this.props;
        const { typeSpecific } = variant;
        return (
            <>
                <Form.Item label="Opacity" help="1 = blackout, ~0.5 = sheer">
                    <InputNumber
                        size="small"
                        min={0.2}
                        max={1}
                        step={0.05}
                        value={typeSpecific.opacity ?? 1}
                        onChange={(v) => onChange('opacity', v)}
                        style={{ width: 110 }}
                    />
                </Form.Item>
                <Form.Item label="Material colors">
                    <Space wrap>
                        {COLOR_FIELDS.map(({ key, label, fallback }) => (
                            <ColorPicker
                                key={key}
                                size="small"
                                showText={() => label}
                                value={typeSpecific[key] ? `#${stripHash(typeSpecific[key])}` : fallback}
                                onChange={(c) => onChange(key, stripHash(c.toHexString()))}
                            />
                        ))}
                    </Space>
                </Form.Item>
                <Form.Item label="Pattern repeat (in)" help="Physical size of one fabric pattern tile; blank stretches the swatch once per panel">
                    <InputNumber
                        size="small"
                        min={0.5}
                        step={0.5}
                        value={typeSpecific.uSize}
                        onChange={(v) => {
                            onChange('uSize', v);
                            onChange('vSize', v);
                        }}
                        style={{ width: 110 }}
                    />
                </Form.Item>
            </>
        );
    }
}
